import { EventEmitter, Injectable } from '@angular/core';
import {
  SceneService,
  ModelLoaderService,
  DetailsPopupService,
} from '../services/index';
import * as THREE from 'three';
import { Object3D, Vector3 } from 'three';
import { ServicecallService } from 'src/app/services/servicecall.service';
import { timer } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class TagUntagService {
  modelLoaded =new EventEmitter<boolean>();
  private _filledForkLiftTag: THREE.Group;
  private _filledForkliftExit: THREE.Group;
  private _filledForkliftInLane: THREE.Group;
  private _zPos: number[] = [];
  private _zPosTop: number[] = [];
  private _isAnimating: boolean = false;
  private _isUntagMonotainerAnimating: boolean = false;
  private _isAnimatingInLane: boolean = false;
  private _scene = this._sceneService.getScene();
  private _tagged: Object3D[] = [];
  private _taggedMonotainers: Object3D[] = [];
  private _objectsRemoveUntagged: Object3D[] = [];
  private _inside: Map<string, boolean> = new Map<string, boolean>();
  private _misplace: Map<string, boolean> = new Map<string, boolean>();
  private _untagged: Map<string, boolean> = new Map<string, boolean>();
  private _monotainerStackPos: Map<string, string> = new Map<string, string>();
  private _laneName:Map<string,string>=new Map<string,string>();
  private _laneParams: {
    [key: string]: { lane: number; xOffset: number; monotainerXOffset: number };
  } = {};
  private _lane: number = -1;
  private _xOffset: number = -1.8;
  private _laneXPosition:number[]=[];
  private _monotainerXOffsetOffset: number = -2.1;
  private _startPos: Vector3;
  private _length: number;
  private _animationQueueUntag: string[] = []; 
  private _tagMonotainersQueue: string[] = []; 
  constructor(
    private _detailsPopUpService: DetailsPopupService,
    private _sceneService: SceneService,
    private _modelLoaderService: ModelLoaderService,
    private _service: ServicecallService
  ) {
    this._filledForkliftInLane =
      this._modelLoaderService.getFilledForkLiftModelInLane();
    this._service.getPlanogramData('default').subscribe((res: any) => {
      if (res?.length) {
        this._length = res.length;
        this._zPos = Array(res.length).fill(-4);
        this._zPosTop = Array(res.length).fill(-4);
        res.map((elem: any) => {
          this._laneParams[elem.zoneName] = {
            lane: (this._lane += 1),
            xOffset: (this._xOffset += 1.6),
            monotainerXOffset: (this._monotainerXOffsetOffset += 1.6),
          };
        });
      }
    });
  }
  /**
   * Sets start position of forklift
   * @param position
   */
  setStartPosition(position: Vector3) {
    this._startPos = position;
  }
  /**
   * Sets lane stack position to 0
   */
  setLaneStackPosition() {
    this._zPos = Array(this._length).fill(-4);
    this._zPosTop = Array(this._length).fill(-4);
  }

  /**
   * Sets lane xposition so that it corresponds with 
   * lane position in 3d Scene
   * @param laneXarray 
   */
   public setLaneXPosition(laneXarray:number)
  {
    this._laneXPosition.push(laneXarray);
  }
  /**
   * Clears inlane Monotainers on destroy of
   * my scene component
   */
  clearInlaneMonotainers() {
    this._tagged = [];
    this._taggedMonotainers = [];
    this._objectsRemoveUntagged = [];
  }

  /**
   * Clears from sort area
   * @param id 
   */
  clearFromSortArea(id: string){
    const filteredObjects = this._scene.children.filter(
      (object) => object.name === id
    );
    this._tagged.push(...filteredObjects);
    this._taggedMonotainers.push(...filteredObjects);
    this._tagged.forEach((object) => {
      this._detailsPopUpService.removeIcon(object);
      this._scene.remove(object);
    });
    this._tagged = [];
  }
  
/**
 * 
 * Starts Tag animation
 * @param id 
 * @param taggedList 
 * @returns monotainer
 */
  async tagMonotainer(id: string, taggedList:Map<string,boolean>): Promise<void> {
    return new Promise(async (resolve) => {
      taggedList.forEach((value,key)=>{
        if(!this._tagMonotainersQueue.includes(key) && value==false)
        {
          this._tagMonotainersQueue.push(key);
        }
      })
      const filteredObjects = this._scene.children.filter(
        (object) => object.name === id
      );
      this._tagged.push(...filteredObjects);
      this._taggedMonotainers.push(...filteredObjects);
      this._tagged.forEach((object) => {
        this._detailsPopUpService.removeIcon(object);
        this._scene.remove(object);
      });
      this._tagged = [];
      if (this._isAnimating) {
        return new Promise<void>((resolve) => {
          const waitForAnimation = () => {
            if (this._isAnimating) {
              requestAnimationFrame(waitForAnimation);
            } else {
              resolve();
            }
          };
          waitForAnimation();
        });
      }
      this._isAnimating=true;
      await this._animateForkLiftOnSortArea();
      resolve(); // Resolve the Promise when animation is done
      this._tagMonotainersQueue=[];
    });
  }

  /**
   * Animates fork lift in sort area
   * @returns fork lift
   */
  private _animateForkLiftOnSortArea(): Promise<void> {
    return new Promise(async (resolve) => {
      // Get Created renderer and camera
      this._filledForkLiftTag =
        this._modelLoaderService.getFilledForkLiftModel();
      this._scene = this._sceneService.getScene();
      this._detailsPopUpService.appendNameForklift(this._filledForkLiftTag,this._tagMonotainersQueue);
      await this._animateToPosition(
        new THREE.Vector3(
          this._filledForkLiftTag.position.x,
          this._filledForkLiftTag.position.y,
          -1
        )
      ); // For straight animation
      this._filledForkLiftTag.rotateY(Math.PI / 2);
      await this._animateToPosition(
        new THREE.Vector3(
          -4,
          this._filledForkLiftTag.position.y,
          this._filledForkLiftTag.position.z
        )
      ); // For left animation
      this._filledForkLiftTag.rotateY(Math.PI / 2);
      await this._animateToPosition(
        new THREE.Vector3(
          this._filledForkLiftTag.position.x,
          this._filledForkLiftTag.position.y,
          -8
        )
      ); // For straight animation
      await this._detailsPopUpService.removeAlertFromForklift(this._filledForkLiftTag);
      this._filledForkLiftTag.rotateY(Math.PI);
      this._filledForkLiftTag.position.copy(this._startPos);
      resolve(); // Resolve the Promise when the animation is complete
    });
  }

  /**
   * Animates forklift along a line from start position to target
   * @param targetPosition
   * @returns to position
   */
  private _animateToPosition(targetPosition: THREE.Vector3): Promise<void> {
    return new Promise<void>((resolve) => {
      const renderer = this._sceneService.getRenderer();
      const camera = this._sceneService.getCamera();
      const maxFrames = 120; // Limit the number of animation frames
      let frameCount = 0;
      const animate = () => {
        const distance = targetPosition.distanceTo(
          this._filledForkLiftTag.position
        );
        const speed = 0.09;
        const tolerance = 0.1; // Tolerance for reaching the target position
        if (distance > tolerance && frameCount < maxFrames) {
          const direction = targetPosition
            .clone()
            .sub(this._filledForkLiftTag.position)
            .normalize();
          this._filledForkLiftTag.position.add(direction.multiplyScalar(speed));
          renderer.render(this._scene, camera);
          requestAnimationFrame(animate);
          frameCount++;
        } else {
          this._filledForkLiftTag.position.copy(targetPosition);
          this._isAnimating = false;
          resolve();
        }
      };
      animate();
    });
  }

  /**
   * Removefroms lane if state of monotainer is outside
   * @param outside 
   */
  removefromLane(outside:Map<string,boolean>)
  {
    outside.forEach((value,key)=>{
      this._taggedMonotainers.forEach((object) => {
       if(object.name===key)
       {
        this._detailsPopUpService.removeIcon(object);
        this._scene.remove(object);
        this._arrangeLane(key);
       } 
    })
    })
}
  /**
   * Starts inlane animation
   * @param inLaneMonotianers
   * @param monotainerLaneName
   * @param monotainerStack
   * @param inside
   * @param untag
   * @param misplace
   */
  gotoLane(
    inLaneMonotianers: Map<string, boolean>,
    monotainerLaneName: Map<string, string>,
    monotainerStack: Map<string, string>,
    inside: Map<string, boolean>,
    untag: Map<string, boolean>,
    misplace: Map<string, boolean>,
      ) {
    this._inside = inside;
    this._untagged = untag;
    this._misplace = misplace;
    this._monotainerStackPos=monotainerStack;
    this._laneName=monotainerLaneName;
    inLaneMonotianers.forEach((value, key) => {
      if (value == false) {
        const filteredObjects = this._scene.children.filter(
          (object) => object.name === key && object.children.length <= 3
        );
          const exists = this._taggedMonotainers.some((taggedObject) => taggedObject.name === key);
        if (!exists) {
          this._taggedMonotainers.push(...filteredObjects);
        }
      }
    });
    
    inLaneMonotianers.forEach((value, key) => {
      if (value == false) {
        inLaneMonotianers.set(key, true);
        const laneName = monotainerLaneName.get(key);
        const params = this._laneParams[laneName]; //corresponding lane number for monotainers
        if (params) {
          this._taggedMonotainers.forEach((element) => {
            if (element.name == key && element.children.length <=3 && inLaneMonotianers.get(element.name)) {
              if (monotainerStack.get(element.name) === 'bottom') {
                this._stackInLane(
                  params.lane,
                  params.xOffset,
                  params.monotainerXOffset,
                  element
                );
              } else {
                this._stackInLaneTop(
                  params.lane,
                  params.xOffset,
                  params.monotainerXOffset,
                  element
                );
              }
            }
          });
        }
      }
    });
  }

  /**
   * Stacks tagged monotainers in lane(bottom)
   * @param laneNumber
   * @param forkliftXpos
   * @param monotianerXpos
   * @param inLaneObjects
   */
  private _stackInLane(
    laneNumber: number,
    forkliftXpos: number,
    monotianerXpos: number,
    inLaneObjects: THREE.Object3D<THREE.Object3DEventMap>
  ) {
    const forkLiftposition = new THREE.Vector3(forkliftXpos, 2.6, 7);
    const monotainerPosition = new THREE.Vector3(
      monotianerXpos,
      3,
      (this._zPos[laneNumber] += 1)
    );
    this._setInLane(inLaneObjects, forkLiftposition, monotainerPosition);
  }

  /**
   * Stacks monotainers inlane (top)
   * @param laneNumber
   * @param forkliftXpos
   * @param monotianerXpos
   * @param inLaneObjects
   */
  private _stackInLaneTop(
    laneNumber: number,
    forkliftXpos: number,
    monotianerXpos: number,
    inLaneObjects: THREE.Object3D<THREE.Object3DEventMap>
  ) {
    const forkLiftposition = new THREE.Vector3(forkliftXpos, 2.6, 7);
    const monotainerPosition = new THREE.Vector3(
      monotianerXpos,
      3.9,
      (this._zPosTop[laneNumber] += 1)
    );
    this._setInLane(inLaneObjects, forkLiftposition, monotainerPosition);
  }
  /*
  starts a animation to get monotainer in respective Lane
  */
  private async _setInLane(
    objectsInLane: THREE.Object3D,
    forkLiftPos: THREE.Vector3,
    monotainerPos: THREE.Vector3
  ) {
    this._filledForkliftInLane =
    this._modelLoaderService.getFilledForkLiftModelInLane();
    this._filledForkliftInLane.position.copy(forkLiftPos);
      this._scene.add(this._filledForkliftInLane);
      await this._animateToPositionInLane(
        new THREE.Vector3(
          this._filledForkliftInLane.position.x,
          this._filledForkliftInLane.position.y,
          5
        ),
        this._filledForkliftInLane
      )
    timer(1000).subscribe(() => {
      this._scene.remove(this._filledForkliftInLane);
    });
    objectsInLane.position.copy(monotainerPos);
    this._scene.add(objectsInLane);
    this._misplace.forEach((value, key) => {
      if (objectsInLane.name == key) {
        this._detailsPopUpService.appendIcon(objectsInLane,'FFD600');
      }
    });
    this._inside.forEach((value, key) => {
      if (objectsInLane.name == key) {
        this._detailsPopUpService.appendIcon(objectsInLane,'008000');
      }
    });
    this._untagged.forEach((value, key) => {
      if (objectsInLane.name == key) {
        this._detailsPopUpService.appendIcon(objectsInLane,'FF0000');
      }
    });
  }
  /**
   * Animates forklift to lane
   * @param targetPosition
   * @param forkLiftinLane
   * @returns to position in lane
   */
  private _animateToPositionInLane(
    targetPosition: THREE.Vector3,
    forkLiftinLane: THREE.Group<THREE.Object3DEventMap>
  ): Promise<void> {
    if (this._isAnimatingInLane) {
      // Return a Promise that resolves when the previous animation is done.
      return new Promise<void>((resolve) => {
        const waitForAnimation = () => {
          if (this._isAnimatingInLane) {
            requestAnimationFrame(waitForAnimation);
          } else {
            resolve();
          }
        };
        waitForAnimation();
      });
    }
    this._isAnimatingInLane = true;
    return new Promise<void>((resolve) => {
      const renderer = this._sceneService.getRenderer();
      const camera = this._sceneService.getCamera();
      const maxFrames = 120; // Limit the number of animation frames
      let frameCount = 0;
      const animate = () => {
        const distance = targetPosition.distanceTo(forkLiftinLane.position);
        const speed = 0.09;
        const tolerance = 0.1; // Tolerance for reaching the target position
        if (distance > tolerance && frameCount < maxFrames) {
          const direction = targetPosition
            .clone()
            .sub(forkLiftinLane.position)
            .normalize();
          forkLiftinLane.position.add(direction.multiplyScalar(speed));
          renderer.render(this._scene, camera);
          requestAnimationFrame(animate);
          frameCount++;
        } else {
          forkLiftinLane.position.copy(targetPosition);
          this._isAnimatingInLane = false;
          resolve();
        }
      };
      animate();
    });
  }

  /**
   * starts untag animations
   * @param name
   * @returns tag monotainer
   */
  async unTagMonotainer(name: string): Promise<void> {
    this._animationQueueUntag.push(name);
    if (this._isUntagMonotainerAnimating) {
      return new Promise<void>((resolve) => {
        const waitForAnimation = () => {
          if (this._isUntagMonotainerAnimating) {
            setTimeout(waitForAnimation, 100); // Check again after a short delay
          } else {
            resolve();
          }
        };
        waitForAnimation();
      });
    }
    this._isUntagMonotainerAnimating = true;
    const filteredObjects = this._scene.children.filter(
      (object) => object.name === name && object.children.length <= 3
    );
    this._objectsRemoveUntagged.push(...filteredObjects);
    this._objectsRemoveUntagged.forEach((object) => {
      object.traverse(function (child) {
        if (child.name === 'icon') {
          child.removeFromParent();
        }
      });
      this._scene.remove(object);
    });
    this._arrangeLane(name);
    this._filledForkliftExit =
      this._modelLoaderService.getFilledForkLiftModelExit();
    const forkLiftposition = new THREE.Vector3(4, 2.6, 5);
    this._filledForkliftExit.position.copy(forkLiftposition);
    this._filledForkliftExit.rotateY(Math.PI / 2);
    this._scene.add(this._filledForkliftExit);
    await this._animateToPositionExit(
      new THREE.Vector3(
        9,
        this._filledForkliftExit.position.y,
        this._filledForkliftExit.position.z
      )
    );
    this._filledForkliftExit.rotateY(Math.PI / 2);
    setTimeout(() => {
      this._scene.remove(this._filledForkliftExit);
      this._filledForkliftExit.rotateY(Math.PI);
      this._isUntagMonotainerAnimating = false;
      this._animationQueueUntag.shift();
      const nextItem = this._animationQueueUntag.shift();
      if (nextItem) {
          this.unTagMonotainer(nextItem);
      }
    }, 1000);
  }
  /**
   * Animates to position exit
   * @param targetPosition
   * @returns to position exit
   */
  private _animateToPositionExit(targetPosition: THREE.Vector3): Promise<void> {
    return new Promise<void>((resolve) => {
      const renderer = this._sceneService.getRenderer();
      const camera = this._sceneService.getCamera();
      const maxFrames = 120; // Limit the number of animation frames
      let frameCount = 0;
      this._filledForkliftExit =
        this._modelLoaderService.getFilledForkLiftModelExit();
      const animate = () => {
        const distance = targetPosition.distanceTo(
          this._filledForkliftExit.position
        );
        const speed = 0.09;
        const tolerance = 0.1; // Tolerance for reaching the target position
        if (distance > tolerance && frameCount < maxFrames) {
          const direction = targetPosition
            .clone()
            .sub(this._filledForkliftExit.position)
            .normalize();
          this._filledForkliftExit.position.add(
            direction.multiplyScalar(speed)
          );
          renderer.render(this._scene, camera);
          requestAnimationFrame(animate);
          frameCount++;
        } else {
          this._filledForkliftExit.position.copy(targetPosition);
          resolve();
        }
      };
      animate();
    });
  }

  /**
   * Arranges the Stack Queue on untag
   * @param monotainer untagged monotainer
   */
   private _arrangeLane(monotainer:string)
   {
     const laneName=this._laneName.get(monotainer);
     if(laneName){
       const laneNum=this._laneParams[laneName].lane;
     if(this._monotainerStackPos.get(monotainer)==='bottom')
     { 
       this._zPos[laneNum]-=1;
     }else
     {
       this._zPosTop[laneNum]-=1;
     }
     this._inside.delete(monotainer);
     this._untagged.delete(monotainer);
     this._misplace.delete(monotainer);
     }  
   }
}